export enum Utility {
  Communication = "comms",
  Complaint = "complaints",
  Note = "notes",
  Freshdesk = "freshdesk",
  Junifer = "junifer",
  Bill = "bill",
  Payment = "payments",
  Email = "email",
  Appointment = "appointment",
  Other = "other",
  IHD = "ihd",
  Case = "case",
  Debt = "debt",
}

export type UtilityObject = {
  [key in Utility]: string
}

export const getUtilityName = (util: Utility): string => {
  return utilityMap[util]
}

const utilityMap = {
  [Utility.Communication]: "Communication",
  [Utility.Complaint]: "Complaint",
  [Utility.Note]: "Note",
  [Utility.Freshdesk]: "Freshdesk",
  [Utility.Junifer]: "Junifer",
  [Utility.Bill]: "Bill",
  [Utility.Payment]: "Payment",
  [Utility.Email]: "Email",
  [Utility.Appointment]: "Meter Appointment",
  [Utility.Other]: "Other",
  [Utility.IHD]: "IHD",
  [Utility.Case]: "Case",
  [Utility.Debt]: "Debt",
} as UtilityObject
